import { render } from "./NewsItemForm.vue?vue&type=template&id=17000528&scoped=true"
import script from "./NewsItemForm.vue?vue&type=script&lang=js"
export * from "./NewsItemForm.vue?vue&type=script&lang=js"

import "./NewsItemForm.vue?vue&type=style&index=0&id=17000528&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17000528"]])

export default __exports__
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QColor from 'quasar/src/components/color/QColor.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QMenu,QColor});
